export const GET_FUNDS_START = 'GET_FUNDS_START';
export const GET_FUNDS_END = 'GET_FUNDS_END';
export const GET_FUND_START = 'GET_FUND_START';
export const GET_FUND_END = 'GET_FUND_END';
export const GET_TYPEAHEAD_START = 'GET_TYPEAHEAD_START';
export const GET_TYPEAHEAD_END = 'GET_TYPEAHEAD_END';
export const CHANGE_FILTER = 'CHANGE_FILTER';
export const GET_FILTERS_START = 'GET_FILTERS_START';
export const GET_FILTERS_END = 'GET_FILTERS_END';
export const TOGGLE_SHARE_CLASS_PERFORMANCE = 'TOGGLE_SHARE_CLASS_PERFORMANCE';
export const TOGGLE_SHARE_CLASS = 'TOGGLE_SHARE_CLASS';
export const TOGGLE_FUND = 'TOGGLE_FUND';
export const TOGGLE_ALL_FUNDS = 'TOGGLE_ALL_FUNDS';
export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const TOGGLE_HISTORICAL_PRICES_MODAL = "TOGGLE_HISTORICAL_PRICES_MODAL";
export const CHANGE_SORT_ORDER = "CHANGE_SORT_ORDER";
export const GET_DISCLAIMERS = "GET_DISCLAIMERS";
export const UPDATE_COMPARE = "UPDATE_COMPARE";
export const GET_BENCHMARKS = "GET_BENCHMARKS";
export const GET_WATCHLIST = "GET_WATCHLIST";
export const ADD_TO_WATCHLIST = "ADD_TO_WATCHLIST";
export const REMOVE_FROM_WATCHLIST = "REMOVE_FROM_WATCHLIST";
export const INFINITE_SCROLL_START = "INFINITE_SCROLL_START";
export const INFINITE_SCROLL_END = "INFINITE_SCROLL_END";
export const GET_SHARE_PRICE_FUNDLIST = "GET_SHARE_PRICE_FUNDLIST";
export const GET_SHARE_CLASSES_START = "GET_SHARE_CLASSES_START";
export const GET_SHARE_CLASSES_END = "GET_SHARE_CLASSES_END";



// WEBPACK FOOTER //
// ./src/client/actions/constants.ts